/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  function localizeHomeReviewsTitle() {
    var container = document.querySelector('[data-home-reviews-title]');

    if (!container) {
      return;
    }

    var title = container.getAttribute('data-home-reviews-title');

    container.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (heading) {
      if (heading.textContent.trim() === 'Let customers speak for us') {
        heading.textContent = title;
      }
    });
  }

  function watchHomeReviewsTitle() {
    var container = document.querySelector('[data-home-reviews-title]');

    if (!container) {
      return;
    }

    localizeHomeReviewsTitle();

    new MutationObserver(localizeHomeReviewsTitle).observe(container, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', watchHomeReviewsTitle);

  var config = window.freeGiftCampaign;

  if (!config || !config.enabled) {
    return;
  }

  if (window.Shopify && window.Shopify.designMode) {
    return;
  }

  var syncPromise = null;
  var refreshScheduled = false;

  function route(path) {
    var root = window.routes && window.routes.rootUrl ? window.routes.rootUrl : '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function isSystemGift(item) {
    return item.properties && String(item.properties._free_gift) === 'true';
  }

  function qualifyingSubtotal(cart) {
    return cart.items.reduce(function (subtotal, item) {
      return isSystemGift(item) ? subtotal : subtotal + item.final_line_price;
    }, 0);
  }

  function desiredGift(subtotal) {
    if (subtotal >= config.giftB.thresholdCents) {
      return config.giftB;
    }

    if (subtotal >= config.giftA.thresholdCents) {
      return config.giftA;
    }

    return null;
  }

  function formatKd(cents) {
    return (cents / 100).toFixed(3);
  }

  function updateMessages(subtotal) {
    var message;
    var state;

    if (subtotal < config.giftA.thresholdCents) {
      message = config.messages.below.replace('[amount]', formatKd(config.giftA.thresholdCents - subtotal));
      state = 'below';
    } else if (subtotal < config.giftB.thresholdCents) {
      message = config.messages.tierA.replace('[amount]', formatKd(config.giftB.thresholdCents - subtotal));
      state = 'tier-a';
    } else {
      message = config.messages.tierB;
      state = 'tier-b';
    }

    document.querySelectorAll('[data-free-gift-message]').forEach(function (element) {
      element.classList.remove(
        'free-gift-cart-message--below',
        'free-gift-cart-message--tier-a',
        'free-gift-cart-message--tier-b'
      );
      element.classList.add('free-gift-cart-message--' + state);

      var text = element.querySelector('p');
      if (text) {
        text.textContent = message;
      }
    });
  }

  function fetchCart() {
    return fetch(route('cart.js'), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to read cart');
      }

      return response.json();
    });
  }

  function updateGiftLines(updates) {
    return fetch(route('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to update gift lines');
      }

      return response.json();
    });
  }

  function addGift(gift) {
    return fetch(route('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: gift.variantId,
            quantity: 1,
            properties: {
              _free_gift: 'true',
              _gift_tier: gift.tier
            }
          }
        ]
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to add free gift');
      }

      return response.json();
    });
  }

  function requestCartRefresh() {
    if (refreshScheduled) {
      return;
    }

    refreshScheduled = true;

    window.setTimeout(function () {
      refreshScheduled = false;

      if (window.location.pathname.replace(/\/+$/, '') === '/cart') {
        window.location.reload();
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false }
      }));
    }, 0);
  }

  function reconcileCart() {
    if (syncPromise) {
      return syncPromise;
    }

    syncPromise = fetchCart()
      .then(function (cart) {
        var subtotal = qualifyingSubtotal(cart);
        var desired = desiredGift(subtotal);
        var systemGifts = cart.items.filter(isSystemGift);
        var keptGift = null;
        var updates = {};

        updateMessages(subtotal);

        systemGifts.forEach(function (item) {
          var matchesDesired = desired &&
            Number(item.variant_id) === Number(desired.variantId) &&
            String(item.properties._gift_tier) === String(desired.tier);

          if (matchesDesired && !keptGift) {
            keptGift = item;

            if (item.quantity !== 1) {
              updates[item.key] = 1;
            }
          } else {
            updates[item.key] = 0;
          }
        });

        var updateKeys = Object.keys(updates);
        var updateRequest = updateKeys.length ? updateGiftLines(updates) : Promise.resolve(cart);

        return updateRequest.then(function () {
          if (desired && !keptGift) {
            return addGift(desired).then(function () {
              return true;
            });
          }

          return updateKeys.length > 0;
        });
      })
      .then(function (changed) {
        if (changed) {
          requestCartRefresh();
        }

        return changed;
      })
      .catch(function (error) {
        console.error('[Free gift campaign]', error);
        return false;
      })
      .finally(function () {
        syncPromise = null;
      });

    return syncPromise;
  }

  function handleCheckout(event) {
    var checkoutButton = event.target.closest('[name="checkout"]');

    if (!checkoutButton) {
      return;
    }

    var form = checkoutButton.closest('form');

    if (!form) {
      return;
    }

    event.preventDefault();
    checkoutButton.disabled = true;

    reconcileCart().then(function () {
      var checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      form.appendChild(checkoutInput);
      form.submit();
    });
  }

  function scheduleInitialReconcile() {
    if (document.body.classList.contains('template-index') && !document.querySelector('[data-free-gift-message]')) {
      return;
    }

    if (window.location.pathname.replace(/\/+$/, '') === '/cart') {
      reconcileCart();
      return;
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(reconcileCart, { timeout: 3000 });
      return;
    }

    window.setTimeout(reconcileCart, 2500);
  }

  document.addEventListener('DOMContentLoaded', scheduleInitialReconcile);
  document.addEventListener('cart:rerendered', reconcileCart, true);
  document.addEventListener('click', handleCheckout, true);
})();
